<script setup lang="ts">
  import type { CSSProperties } from 'vue';
  import type { BorderStyleType } from '../../../../../lib/cell-border-utils';

  interface Props {
    modelValue: BorderStyleType;
  }

  defineProps<Props>();

  const emit = defineEmits<{
    (e: 'update:modelValue', value: BorderStyleType): void;
  }>();

  const styles: { value: BorderStyleType; label: string; cssStyle: string }[] = [
    { value: 'solid', label: 'Sólido', cssStyle: 'solid' },
    { value: 'dashed', label: 'Tracejado', cssStyle: 'dashed' },
    { value: 'dotted', label: 'Pontilhado', cssStyle: 'dotted' },
  ];
</script>

<template>
  <div class="border-style-picker">
    <button
      v-for="style in styles"
      :key="style.value"
      v-tippy="{
        content: style.label,
        placement: 'top',
        theme: 'custom',
        trigger: 'mouseenter',
        hideOnClick: true,
      }"
      type="button"
      :class="['border-style-btn', modelValue === style.value ? 'active' : '']"
      :aria-label="style.label"
      @click="emit('update:modelValue', style.value)"
    >
      <span
        class="border-style-preview"
        :style="{ borderTopStyle: style.cssStyle } as CSSProperties"
      />
    </button>
  </div>
</template>

<style scoped>
  .border-style-picker {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 8px;
    min-width: 100px;
  }

  .border-style-btn {
    display: flex;
    align-items: center;
    height: 28px;
    padding: 0 8px;
    border: none;
    background: transparent;
    cursor: pointer;
    border-radius: 4px;
    transition: background-color 0.15s ease;
  }

  .border-style-btn:hover {
    background-color: var(--color-gray-01);
  }

  .border-style-btn.active {
    background-color: var(--color-gray-01);
  }

  .border-style-preview {
    display: block;
    width: 100%;
    height: 0;
    border-top-width: 2px;
    border-top-color: var(--color-gray-07);
  }

  .border-style-btn.active .border-style-preview {
    border-top-color: var(--theme-secondary, #fb7185);
  }
</style>
